<template>

  <v-content v-if="loading">

    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>

    <!-- 标题 -->
    <v-flex class="back left-center-style "
            :style=" {background:' linear-gradient(to left, rgba(5, 11, 31, 0.1), rgba(5, 11, 31, 0.8)), url('+ image +')'}">
      <v-flex class="text1">满足客户需求</v-flex>
      <v-flex class="text1 text2">为服务而生</v-flex>
    </v-flex>

    <!-- 内容 -->
    <v-row class="vision-row "
           v-for="(item,i) in dataList"
           :key="i">

      <!-- 左部 -->

      <v-row class="left-style center-style">
        <v-row class="product"
               v-for="(item2,i) in item.list"
               :key="i">
          <div style="width:40%">
            <v-flex class="product-image">
              <img class="image"
                   @click="$router.push({name:'ProductContent',query: {productId:item2.productId,productList:item.list}}) "
                   :src="item2.photo" />
            </v-flex>

            <v-flex class="product-date">
              {{item2.createTime}}
            </v-flex>
          </div>

          <div style="width:60%;min-width: 300px;position:relative;">
            <v-flex class="product-title">
              {{item2.productName}}
            </v-flex>

            <v-flex class="product-content">
              {{item2.productDesc}}
            </v-flex>
            <v-btn class="look-more"
                   @click="$router.push({name:'ProductContent',query: {productId:item2.productId,productList:item.list}}) ">
              查看详情>>>
            </v-btn>
          </div>
        </v-row>

      </v-row>

      <!-- 分割线 -->
      <v-divider vertical></v-divider>

      <!-- 右部-->
      <v-flex class="vision-title">{{item.typeName}}
        <v-flex class="vision-title2">{{item.note}}</v-flex>
      </v-flex>

    </v-row>
  </v-content>

</template>
<script>
import Loading from '@/components/core/Loading' //引入新闻列表分页 api 接口

export default {
  components: { Loading },
  data () {
    return {
      image: require('@/images/background/breadcrumbs2.jpg'),
      loading: false,
      isLoading: false,
      dataList: {}

    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.$emit("updateToolbarValue", 3)
  },
  methods: {
    init () {
      this.isLoading = true;
      this.$store
        .dispatch("GetProductsAndTypes")
        .then(response => {
          this.dataList = response.data.data;
          this.isLoading = false;
        })
        .catch(() => { this.isLoading = false; });
      this.loading = true;
    }
  }

}
</script>

<style scoped>
.left-center-style {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.center-style {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.back {
  height: 300px;
  width: 100%;
  background-position: center center !important;
}
.text1 {
  max-width: 370px;
  margin-left: 30px;
  flex: none;
  font-size: 30px;
  color: white;
  font-family: "宋体";
}
.text2 {
  font-size: 20px;
}

.vision-row {
  padding-top: 40px;
  padding-bottom: 50px;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vision-title {
  width: 35%;
  max-width: 400px;
  font-size: 30px;
  color: #2a2e2e;
  letter-spacing: 0;
  font-family: "微软雅黑";
  flex: none;
  text-align: center;
  margin-left: 10px;
}
.vision-title2 {
  font-size: 15px;
}
.left-style {
  width: 70%;
  max-width: 800px;
  padding: 20px;
  margin-right: 10px;
}
.product {
  max-width: 900px;
  width: 100%;
  margin: 10px;
}
.product-image {
  width: 100%;
  min-width: 300px;
  height: 250px;
  flex: none;
  cursor: pointer;
}
.image {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.product-date {
  height: 30px;
  width: 100px;
  background: black;
  color: azure;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product-title {
  margin: 10px;
  font-size: 20px;
}
.product-content {
  margin: 10px;
  font-size: 14px;
  color: gray;
}
.look-more {
  font-size: 14px;
  background: #42a5f6 !important;
  color: #fff;
  position: absolute;
  right: 0;
  bottom: 0px;
}
</style>